export const adStyle = theme => ({
  '.ads': {
    marginBlock: 6,
    display: 'flex',
    justifyContent: 'center',
  },
  '#carbonads': {
    border: `1px dashed ${theme.palette.divider}`,
    overflow: 'hidden',
    marginInline: 2.5,
    padding: 1.25,
    maxWidth: 16 * theme.sizing.mdGridSize,
    borderRadius: 1,
    lineHeight: 1.5,
    '& a': {
      color: 'inherit',
      textDecoration: 'none'
    },
    '& span': {
      display: 'block',
      position: 'relative',
      overflow: 'hidden'
    },
    '& .carbon-wrap': {
      display: 'flex'
    },
    '& .carbon-img': {
      marginInlineEnd: '1em',
      '& img': {
        display: 'block'
      }
    },
    '& .carbon-text': {
      textAlign: 'start'
    },
    '& .carbon-poweredby': {
      display: 'block',
      textAlign: 'end',
      color: 'text.disabled',
      fontSize: 'overline.fontSize',
      lineHeight: 1
    }
  }
})
